export const CQCC_USER_INFO_STORAGE_KEY = 'CQCC_USER_INFO';
export const CQCC_USER_INFO_CHANGE_EVENT = 'cqcc-user-info-change';

export interface CqccUserInfo {
  id?: string | number;
  name: string;
  account?: string;
  avatar?: string;
  raw: any;
}

function pickValue(source: any, keys: string[]) {
  if (!source) {
    return '';
  }

  const key = keys.find((item) => source[item]);
  return key ? source[key] : '';
}

function getPayload(response: any) {
  const data = response && response.data ? response.data : response;
  return (
    (data && (data.user || data.member || data.info || data.memberInfo)) ||
    data ||
    {}
  );
}

export function normalizeCqccUserInfo(response: any): CqccUserInfo {
  const payload = getPayload(response);
  const name =
    pickValue(payload, [
      'nickname',
      'nickName',
      'name',
      'realName',
      'userName',
      'username',
      'phone',
      'mobile',
    ]) || '已登录';
  const account = pickValue(payload, ['phone', 'mobile', 'account', 'username']);
  const avatar = pickValue(payload, [
    'avatar',
    'avatarUrl',
    'headimgurl',
    'headImgUrl',
    'headimg',
    'headImg',
    'userPic',
  ]);

  return {
    id: pickValue(payload, ['id', 'memberId', 'userId']),
    name: String(name),
    account: account ? String(account) : '',
    avatar: avatar ? String(avatar) : '',
    raw: payload,
  };
}

export function saveCqccUserInfo(userInfo: CqccUserInfo) {
  localStorage.setItem(CQCC_USER_INFO_STORAGE_KEY, JSON.stringify(userInfo));
  window.dispatchEvent(
    new CustomEvent(CQCC_USER_INFO_CHANGE_EVENT, { detail: userInfo }),
  );
}

export function clearCqccUserInfo() {
  localStorage.removeItem(CQCC_USER_INFO_STORAGE_KEY);
  window.dispatchEvent(new Event(CQCC_USER_INFO_CHANGE_EVENT));
}

export function getStoredCqccUserInfo(): CqccUserInfo | null {
  const value = localStorage.getItem(CQCC_USER_INFO_STORAGE_KEY);
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch (err) {
    localStorage.removeItem(CQCC_USER_INFO_STORAGE_KEY);
    return null;
  }
}
